<div class="container">
  <div class="enhanced-section-header">
    <div class="section-title" *ngFor="let Content of sectionTitle;">
      <div class="title-badge">Premium Collection</div>
      <h2>{{ Content.title }}</h2>
      <p>{{ Content.paragraph }}</p>
    </div>
  </div>

  <div class="premium-tiles-showcase position-relative">
    <!-- Enhanced Navigation Arrows -->
    <button class="nav-arrow prev-nav" (click)="productsCarousel?.prev()">
      <i class='bx bx-chevron-left'></i>
    </button>
    <button class="nav-arrow next-nav" (click)="productsCarousel?.next()">
      <i class='bx bx-chevron-right'></i>
    </button>

    <owl-carousel-o #productsCarousel [options]="productsSlidesOptions">
      <ng-template carouselSlide *ngFor="let Content of singleProductsBox;">
        <div class="tile-product-card">
          <div class="tile-visual">
            <img [src]="Content.mainImg" alt="{{ Content.title }}" class="tile-img">
            <div class="tile-hover-overlay">
              <div class="tile-actions">
                <a href="{{ Content.mainImg }}" class="tile-action-btn view-tile" data-lightbox="tiles">
                  <i class='bx bx-expand'></i>
                  <span>View</span>
                </a>
                <button class="tile-action-btn save-tile">
                  <i class='bx bx-heart'></i>
                  <span>Save</span>
                </button>
              </div>
            </div>
            <!-- Tile Status Badges -->
            <div class="tile-status">
              <span class="status-badge sale-badge" *ngIf="Content.sale">{{ Content.sale }}</span>
              <span class="status-badge stock-badge" *ngIf="Content.outOfStock">{{ Content.outOfStock }}</span>
              <span class="status-badge new-badge">New</span>
            </div>
          </div>
          
          <div class="tile-info">
            <h3 class="tile-name">{{ Content.title }}</h3>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
<section class="vision-values-section pt-100 pb-70">
  <div class="container">
    <div class="section-title text-center">
      <div class="title-badge">Our Vision</div>
      <h2 class="section-heading">Transforming Spaces, Building Trust</h2>
      <p class="section-subheading">
        To be India's most trusted destination for tile and sanitaryware — delivering a seamless, design-forward, and value-rich experience from selection to delivery.
      </p>
    </div>

    <div class="row g-4 mt-4">
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-user-voice'></i>
          </div>
          <h4>Customer First</h4>
          <p>We prioritize our customers in every decision and service we offer.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-check-shield'></i>
          </div>
          <h4>Integrity Always</h4>
          <p>We operate with honesty, fairness, and transparency at all times.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-palette'></i>
          </div>
          <h4>Design-Led</h4>
          <p>We help you craft meaningful spaces, not just install tiles.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-rupee'></i>
          </div>
          <h4>Fair Pricing</h4>
          <p>We ensure value for money with every square foot you buy.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-smile'></i>
          </div>
          <h4>Effortless Experience</h4>
          <p>Simplified processes with clear communication from start to finish.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-bulb'></i>
          </div>
          <h4>Innovation</h4>
          <p>We're always improving to give you better service and selection.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-time-five'></i>
          </div>
          <h4>Quick & Reliable</h4>
          <p>Timely responses and deliveries without compromising quality.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-group'></i>
          </div>
          <h4>Team Ownership</h4>
          <p>Each member is accountable and committed to delivering excellence.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="vision-box">
          <div class="vision-icon">
            <i class='bx bx-link'></i>
          </div>
          <h4>Stronger Together</h4>
          <p>We build long-term relationships with customers, vendors, and partners.</p>
        </div>
      </div>
    </div>
  </div>
</section>